import { render, staticRenderFns } from "./EN.vue?vue&type=template&id=4fae85ab&scoped=true"
import script from "./EN.vue?vue&type=script&lang=js"
export * from "./EN.vue?vue&type=script&lang=js"
import style0 from "./EN.vue?vue&type=style&index=0&id=4fae85ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae85ab",
  null
  
)

export default component.exports